// @flow
import provideUploadsLink from './provideUploadsLink';
import requestAccountDocuments from './requestAccountDocuments';
import requestCategorization from './requestCategorization';
import requestYearlyData from './requestYearlyData';
import type { RequestGeneratorClient } from './types';

const generatedRequestContentOrder: ((RequestGeneratorClient) => string)[] = [
  requestAccountDocuments,
  requestYearlyData,
  provideUploadsLink,
  requestCategorization,
];

const generateRequest = (clientData: RequestGeneratorClient): string =>
  generatedRequestContentOrder
    .map(requestGenerationFunction => requestGenerationFunction(clientData))
    // Remove empty strings
    .filter(s => s)
    // Concatenate remaining strings with an empty line in between each
    .join('\n\n');

export default generateRequest;
